import React, { useState, useEffect } from 'react';
import { Button, Spinner, Row, Col } from 'react-bootstrap';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useProvider, Toast } from '../context/MenuProvider';
import Swal from 'sweetalert2';


dayjs.locale('pt-br');

const Feedback = () => {
  const {
    crud,
    auth,
    hasPerms,
  } = useProvider();
  const { get, del, loading } = crud || {};
  const [empresa, setEmpresa] = useState(auth?.empresa);
  const [feedback, setFeedback] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  const excluirFeedback = async (x) => {
      if(!hasPerms("feedback.delete_feedback")) return;
      await Swal.fire({
        title: "Exluir esta feedback?",
        text: "Excluir o feedback definitivo, esta ação não pode ser revertida.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, excluir!"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try {
            await del(`/feedback/feedbacks/${x.id}/`);
            setFeedback((prevItem) => prevItem.filter(item => item.id !== x.id));
            Toast.fire({ icon: "success", title: "Excluído com sucesso" });
          } catch (err) {
            Toast.fire({ icon: "error", title: "Falha ao excluir" });
            console.error('Erro ao excluir feedback:', err);
          }
        }
      });
  };

  const buscarFeedback = async (novaBusca = false) => {
    if(!hasPerms("feedback.view_feedback")) return;
    let url = `/feedback/feedbacks/?expand=feedback_respostas,pergunta&ordering=-data`;
    if (novaBusca) {
      setFeedback([]);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }

    if (!url) return;

    try {
      const response = await get(url, 'pagina');
      if (response) {
        const novosItens = response[0].results;
        setFeedback((itensAnteriores) =>
          novaBusca ? novosItens : [...itensAnteriores, ...novosItens]
        );
        setNextUrl(response[0].next);
      }
    } catch (err) {
      // Toast.fire({ icon: "error", title: "Falha ao buscar produtos" });
    }
  };
  
  useEffect(()=>{
    buscarFeedback(true);
  },[])
  
  useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarFeedback();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, nextUrl]);
    

  const shareWhatsApp = () => {
    let texto = `Oi! Pode deixar uma avaliação sobre meu atendimento? Sua opinião é muito importante.\nObrigado!\n\n`;
    texto += `https://${window.location.host}/catalogo/${empresa?.url}/?p=feedback`;

    const mensagem = encodeURIComponent(texto);
    const url = `whatsapp://send?text=${mensagem}`;
    window.open(url);
  };

  return (
    <>
      {hasPerms("feedback.add_feedback") && <BotaoFlutuante onClick={shareWhatsApp} icon="bi-plus" posicao={1} />}
      <div className="list-group mt-3">
        {feedback.length > 0 ? (
          feedback.map((x, index) => (
            <>
              <div data-aos="fade-up" data-aos-delay={parseInt(`${index}00`)}>
                <RenderizarProduto
                  key={x.id}
                  col="d-none"
                  lm="mb-1"
                  text1={dayjs(x.data).format('DD/MM/YYYY')}
                  extra={(<>
                      {x.anonimo && (<>
                          <Row>
                            <Col className="fs-5">Anônimo</Col>
                            <Col xs="auto">
                              <Button variant="outline-danger" onClick={()=>excluirFeedback(x)} className="btn-sm ms-1">
                                <i className="bi bi-trash"></i>
                              </Button>
                            </Col>
                          </Row>
                      </>)}
                      {!x.anonimo && (<>
                          <Row>
                            <Col className="fs-5">{x.nome||`Sem nome`}</Col>
                            <Col xs="auto">
                              <Button variant="outline-success" onClick={()=>window.open(`whatsapp://send?phone=55${x.telefone?.replace(/\D/g, '')}&text=${encodeURIComponent(`Oi ${x.nome}, obrigado pelo feedback.`)}`)} className="btn-sm ms-1">
                                <i className="bx bxl-whatsapp"></i>
                              </Button>
                              <Button variant="outline-danger" onClick={()=>excluirFeedback(x)} className="btn-sm ms-1">
                                <i className="bi bi-trash"></i>
                              </Button>
                            </Col>
                          </Row>
                      </>)}
                      <div className="border-top py-2">
                        <ol>
                          {x.feedback_respostas.map((res, i) => (
                            <li className="text-muted" key={i}>
                              <div>{res.pergunta.pergunta}</div>
                              <i className="text-danger">{res.resposta}</i>
                            </li>
                          ))}
                        </ol>
                      </div>
                  </>)}
                ></RenderizarProduto>
              </div>
            </>
          ))
        ) : (
          !loading && (
            <p data-aos="fade-up" className="text-center text-muted">
              Nenhum feedback encontrado.
            </p>
          )
        )}
        {loading && (
          <p data-aos="fade-up" className="text-center">
            <Spinner animation="border" />
          </p>
        )}
        {nextUrl && !loading && (
          <Button
            data-aos="fade-up"
            variant="secondary"
            onClick={() => buscarFeedback(false)}
            className="mt-2 text-center"
          >
            Buscar mais...
          </Button>
        )}
      </div>
    </>
  );
};

export default Feedback;